// eslint-disable-next-line no-unused-vars
export const getBreadcrumbStyles = ({ breadcrumb = {} }, { palette = {} }) => ({
  breadcrumbContainer: {
    '& .breadcrumb': {
      display: 'flex',
      height: '44px',
      backgroundColor: palette.neutralLighter,
      marginBottom: '0px',
    },
    '& .breadcrumb-item': {
      display: 'flex',
      alignItems: 'center',
      '& > a:focus': {
        textDecoration: 'none',
        outline: `1px solid ${palette.neutralSecondary}`,
        outlineOffset: -1,
      },
      '& .ms-Button': {
        height: 36,
        border: 'none',
        padding: 0,
        minWidth: 33,
        backgroundColor: palette.neutralLighter,

        '& :hover': {
          backgroundColor: palette.neutralQuaternary,
        },
      },
    },
    '& .overflow-breadcrumb': {
      position: 'relative',
    },
    '& .breadcrumb-divider': {
      padding: '0px 8px',
    },
    '& .chevron-right-icon': {
      fontSize: '12px',
      color: palette.neutralSecondary,
      fontWeight: 'normal',
    },
    '& .iconba-More': {
      color: palette.neutralSecondary,
      fontSize: '16px',
      margin: '5px 0px',
    },
    '& .breadcrumb-text-container:focus': {
      textDecoration: 'none',
      outline: `1px solid ${palette.neutralSecondary}`,
      outlineOffset: -1,
    },
    '& .breadcrumb-item-text': {
      fontSize: '14px',
      color: palette.neutralPrimary,
      maxWidth: '180px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '&.long-text': {
        maxWidth: '400px', // Increasing the max-width for long name. Feel free to increase it even more if needed, this value is randomly picked up.
      },
    },
    '& .current-breadcrumb': {
      fontWeight: '600',
    },
    '& .clickable-item': {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: palette.neutralQuaternary,
      },
    },
    '& .ms-ContextualMenu-Callout': {
      border: 'none',
      '& .ms-ContextualMenu-item': {
        fontSize: '14px',
        fontWeight: 'normal',
        color: palette.neutralPrimary,
        '& .ms-ContextualMenu-item:hover': {
          textDecoration: 'none',
          backgroundColor: palette.neutralLighter,
        },
        '& .breadcrumb-item-text': {
          padding: '7px 10px',
        },
      },
    },
  },
});
